import { registerSW } from 'virtual:pwa-register';
import { logger } from './logger';

/**
 * Register the service worker in autoUpdate mode (registerType:
 * 'autoUpdate' in vite.config.ts). A freshly deployed build installs,
 * activates immediately (skipWaiting + clientsClaim), and `registerSW`
 * reloads open tabs into the new code on its own — no "Refresh" tap.
 *
 * Why auto instead of prompt: a device stuck on a stale bundle (an old
 * index.html referencing chunks the server has since purged) was getting
 * trapped in a reload loop, because the previous 'prompt' strategy left
 * the new SW WAITING for a user tap. The browser always re-fetches the SW
 * script on navigation, so an auto-activating SW lets even a looping tab
 * pick up fresh code within a cycle or two with zero user action. The
 * "What's new" modal still surfaces release notes after the reload.
 *
 * Offline support is unaffected — the worker precaches the app shell the
 * same way regardless of update strategy; only *when* an update takes
 * over changed.
 *
 * No-op in dev (devOptions.enabled: false).
 */
export function registerServiceWorker(): void {
  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      // Re-check for a new build hourly so a phone left open all day in
      // the warehouse still notices a deploy without a manual reload.
      if (!registration) return;
      setInterval(
        () => {
          registration.update().catch((err) => {
            logger.warn('[swUpdate] periodic update check failed', err);
          });
        },
        60 * 60 * 1000,
      );
    },
  });
}
